module.exports = __webpack_public_path__ + "static/media/1001438.80c3a940.png";